import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import offer from './modules/offer'
import modals from './modules/modals'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        app,
        offer,
        modals
    },
    strict: debug,
})